import * as React from 'react';
import { Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

type MenuPopoverProps = {
    menuEntries: { icon: string, text: string, onClick: () => void }[]
}

export function MenuPopover({ menuEntries }: MenuPopoverProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            ><Icon fontSize="small">more_vert</Icon></IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {menuEntries.map((entry, index) => (
                    <MenuItem key={index} onClick={entry.onClick}>
                        <ListItemIcon>
                            <Icon fontSize='medium'>{entry.icon}</Icon>
                        </ListItemIcon>
                        <ListItemText>{entry.text}</ListItemText>
                    </MenuItem>
                ))}
             </Menu>

        </div>
    );
}
